import { ArrowRight, ArrowDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { LocaleLink } from '@/components/LocaleLink';
import { Button } from '@/components/ui/button';
import { useLocale } from '@/hooks/useLocale';
import { landingEvent, beginLandingEntry } from '@/lib/landingAnalytics';

export const CalculatorLink = ({ placement, textOnly = false, children, onClick }) => {
  const { t } = useTranslation();
  const { lang } = useLocale();
  const link = <LocaleLink to="/calculator" data-testid={`landing-calculator-${placement.replaceAll('_', '-')}`}
    className={textOnly ? 'lp-text-link' : undefined}
    onClick={(event) => {
      landingEvent('landing_primary_cta_clicked', lang, placement);
      if (!event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) beginLandingEntry(lang, placement);
      onClick?.();
    }}>
    <span>{children || t('homepage.primaryCta')}</span>
    {!textOnly && <ArrowRight size={18} aria-hidden="true" />}
  </LocaleLink>;
  return textOnly ? link : <Button asChild className="lp-primary">{link}</Button>;
};

export const HowItWorksLink = ({ placement, onClick }) => {
  const { t } = useTranslation();
  const { lang } = useLocale();
  return <a href="#how-it-works" className="lp-text-link" data-testid={`landing-how-${placement}`}
    onClick={() => { landingEvent('landing_secondary_cta_clicked', lang, placement); onClick?.(); }}>
    {t('homepage.secondaryCta')}<ArrowDown size={15} aria-hidden="true" />
  </a>;
};

export const MethodologyLink = ({ placement, children, onClick }) => {
  const { t } = useTranslation();
  const { lang } = useLocale();
  return <LocaleLink to="/methodology" className="lp-text-link" data-testid={`landing-methodology-${placement}`}
    onClick={() => { landingEvent('landing_methodology_clicked', lang, placement); onClick?.(); }}>
    {children || t('homepage.methodologyLink')}<ArrowRight size={15} aria-hidden="true" />
  </LocaleLink>;
};